// Client-side billing helpers. Talks to /api/checkout + /api/checkout-verify.
import { authHeader } from './api.js';

/** Kick off a Checkout session. Returns the URL to redirect to. */
export async function startCheckout({ customerEmail } = {}) {
  const res = await fetch('/api/checkout', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({ customerEmail }),
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const body = await res.json();
      detail = body.detail || body.error || detail;
    } catch {}
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res.json(); // { url, id, mode }
}

/** Verify a session_id after the post-checkout redirect. */
export async function verifyCheckout(sessionId) {
  const res = await fetch('/api/checkout-verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({ sessionId }),
  });
  if (!res.ok) {
    let detail = `HTTP ${res.status}`;
    try {
      const body = await res.json();
      detail = body.detail || body.error || detail;
    } catch {}
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return res.json();
}

/** Read ?checkout=success&session_id=... from the URL after redirect, then strip it. */
export function readCheckoutReturnFromUrl() {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  const status = params.get('checkout');
  if (!status) return null;
  const sessionId = params.get('session_id');
  // Clean the URL so a refresh doesn't re-trigger.
  const url = new URL(window.location.href);
  url.searchParams.delete('checkout');
  url.searchParams.delete('session_id');
  window.history.replaceState({}, '', url.toString());
  return { status, sessionId };
}
